import { jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
export var ResultsDropdownSectionWrapper = function(param) {
    var children = param.children, sectionHeader = param.sectionHeader, suggestionArray = param.suggestionArray, sectionIndex = param.sectionIndex, trackView = param.trackView;
    React.useEffect(function() {
        trackView(sectionHeader, suggestionArray, sectionIndex);
    }, [
        sectionHeader,
        suggestionArray,
        sectionIndex,
        trackView
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            " ",
            children,
            " "
        ]
    });
};
